import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { listUsers } from '../../api/users.js'

function formatDate(value) {
  if (!value) return ''
  const parsed = new Date(value)
  if (Number.isNaN(parsed.getTime())) return String(value)
  return parsed.toLocaleString()
}

export default function UsersListPage() {
  const [state, setState] = useState({ status: 'loading', data: [], error: null })

  function load() {
    setState((s) => ({ ...s, status: 'loading' }))
    listUsers()
      .then((data) => setState({ status: 'ok', data, error: null }))
      .catch((error) => setState({ status: 'error', data: [], error }))
  }

  useEffect(() => { load() }, [])

  return (
    <div className="page">
      <div className="pageHeader">
        <div className="buttonGroup mlAuto">
          <Link to="/" className="button buttonGhost">
            Back
          </Link>
          <Link to="/users/new" className="button buttonPrimary">
            Create
          </Link>
        </div>
      </div>

      <section className="card sectionCard">
        <div className="pageHeader pageHeaderTight">
          <div>
            <div className="cardTitle">Users</div>
          </div>
        </div>

        {state.status === 'loading' ? (
          <p className="muted inlineMessage">Loading users...</p>
        ) : null}

        {state.status === 'error' ? (
          <pre className="codeBlock codeBlockError">{String(state.error?.message || state.error)}</pre>
        ) : null}

        {state.status === 'ok' && state.data.length === 0 ? (
          <p className="muted inlineMessage">No users found.</p>
        ) : null}

        {state.status === 'ok' && state.data.length > 0 ? (
          <table className="table" aria-label="Users list">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Role</th>
                <th>Active</th>
                <th>Created</th>
                <th className="alignRight"></th>
              </tr>
            </thead>
            <tbody>
              {state.data.map((user) => (
                <tr key={user.id}>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      {user.avatar ? (
                        <img src={user.avatar} alt="" style={{ width: 24, height: 24, borderRadius: '50%' }} />
                      ) : null}
                      {user.display_name ?? ''}
                    </div>
                  </td>
                  <td>{user.email ?? ''}</td>
                  <td>{user.role ?? ''}</td>
                  <td>
                    {user.is_active ? (
                      <span className="statusIcon statusIconSuccess" role="img" aria-label="Active">✓</span>
                    ) : (
                      <span className="statusIcon statusIconError" role="img" aria-label="Inactive">✗</span>
                    )}
                  </td>
                  <td>{formatDate(user.created_at)}</td>
                  <td className="alignRight">
                    <span className="tableActions">
                      <button
                        type="button"
                        className="button buttonGhost buttonDanger"
                        disabled
                        aria-label="Delete (disabled)"
                      >
                        Delete
                      </button>
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : null}
      </section>
    </div>
  )
}
